import {AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {TestLink} from '../../../data/models/test-link';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {DOCUMENT, formatDate} from '@angular/common';
import {TestLinkEditDialogComponent} from '../../dialogs/test-link-edit-dialog/test-link-edit-dialog.component';

@Component({
  selector: 'app-test-links-table',
  templateUrl: './test-links-table.component.html',
  styleUrls: ['./test-links-table.component.css']
})
export class TestLinksTableComponent implements OnInit, OnChanges, AfterViewInit {

  readonly sortColumnDefault = 'finishDate';
  readonly sortDirectionDefault = 'asc';
  readonly displayedColumns = ['name', 'startDate', 'finishDate', 'link', 'type', 'active', 'trackTelegramUsers', 'buttons'];
  readonly today = formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss', 'ru');
  readonly baseUrl: string;

  @Input() testId!: number;
  @Input() testLinks!: TestLink[];

  @ViewChild(MatSort) sort!: MatSort;

  @Output() delete = new EventEmitter<TestLink>();

  dataSource!: MatTableDataSource<TestLink>;

  constructor(
    @Inject(DOCUMENT) private document: Document,
    public dialog: MatDialog
  ) {
    this.baseUrl = this.resolveBaseUrl();
  }

  ngOnInit(): void {
    this.dataSource = new MatTableDataSource<TestLink>(this.testLinks);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.testLinks.isFirstChange()) {
      this.dataSource.data = changes.testLinks.currentValue;
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
  }

  onTestLinkDelete(testLink: TestLink): void {
    this.delete.emit(testLink);
  }

  openTestLinkEditor(testLink: TestLink): void {
    const dialogRef = this.dialog.open(TestLinkEditDialogComponent, {
      width: '90vw',
      maxWidth: '500px',
      data: {testId: this.testId, testLink},
    });

    dialogRef.afterClosed().subscribe(editedTestLink => {
      if (editedTestLink) {
          const index = this.testLinks.indexOf(testLink);
          if (index > -1) {
            this.testLinks.splice(index, 1);
          }
          this.testLinks = [...this.testLinks, editedTestLink];
          this.dataSource.data = this.testLinks;
      }
    });
  }

  buildLink(urlCode: string): string {
    const normalizedBase = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;
    return `${normalizedBase}tex/${urlCode}`;
  }

  private resolveBaseUrl(): string {
    const origin = this.document?.location?.origin || (typeof window !== 'undefined' ? window.location.origin : '');
    const baseHref = this.document?.baseURI || origin;
    try {
      const url = new URL(baseHref, origin || undefined);
      const trimmedPath = url.pathname.endsWith('/') ? url.pathname.slice(0, -1) : url.pathname;
      const normalizedPath = trimmedPath === '/' ? '' : trimmedPath;
      return `${url.origin}${normalizedPath}` || url.origin;
    } catch (error) {
      return origin;
    }
  }

}
